export enum ToApproveInvoiceActionNameEnum {
  APPROVE = 'APPROVE',
  HISTORY = 'HISTORY',
  REJECT = 'REJECT',
  REJECT_TO_AMEND = 'REJECT_TO_AMEND',
}
